import * as PropTypes from 'prop-types';
import * as React from 'react';
import RelatedArticle from './related_article';
import { trackView, ARTICLE_TYPE } from '@reverbdotcom/commons/dist/tracker';

class RelatedArticles extends React.Component {
  componentDidMount() {
    this.trackImpression();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.articles.length && this.props.articles.length) {
      this.trackImpression();
    }
  }

  trackImpression() {
    if (this.props.articles.length < 2) { return; }

    trackView({
      componentName: 'RelatedArticleCard',
      type: ARTICLE_TYPE,
      ids: this.props.articles.map(article => article.id),
    });
  }

  render() {
    if (this.props.articles.length < 2) { return null; }

    return (
      <section
        className="article-condensed-card-row"
      >
        <section
          className="article-condensed-card-row__inner"
          data-admin-message={this.props.messageForAdmins}
        >
          {
            this.props.articles.map(article =>
              <RelatedArticle key={article.title} article={article} />)
          }
        </section>
      </section>
    );
  }
}

RelatedArticles.propTypes = {
  articles: PropTypes.array,
  messageForAdmins: PropTypes.string,
};

export default RelatedArticles;



// WEBPACK FOOTER //
// ./javascripts/components/shared/related_articles.jsx